<template xmlns:v-swiper="http://www.w3.org/1999/xhtml">
  <div>
    <div class="main main-custom">
      <div class="primarylists">
        <ul class="container">
          <li>
            <div class="titles clear">
              <div class="title l">
                受講者のよくあるご質問(FAQ)
              </div>
              <div class="lkt-title">
                <p>
                  <ul>
                    <li><a class="lkt-hover" @click="scrollToElement('faq-1')">1. システムにログインできません。どうすればよいですか ？</a></li>
                    <li><a class="lkt-hover" @click="scrollToElement('faq-2')">2. パスワードを忘れました。どうすればよいですか ？</a></li>
                    <li><a class="lkt-hover" @click="scrollToElement('faq-3')">3. PWA化の手順 ？</a></li>
                  </ul>
                </p>
              </div>
            </div>
            <p id="faq-1" class="lkt-mg-b-53"></p>

            <p style="text-align: right;">Ver1.00&emsp;&emsp;2021.04.01</p>

            <div class="link-top"></div>
             <div class="secondlists">
        <ul class="container padding-top">
          <li>
            <div class="titles" id="faq-1">
              <div class="title l">
                1.システムにログインできません。どうすればよいですか？
              </div>
            </div>
            <br />
            <div class="links-top"></div>
            <p>■ご利用のブラウザ環境を確認してください。</p>
            <p>
              &nbsp;&nbsp;&nbsp;&nbsp;本システムは以下のブラウザ環境でのご利用をおすすめいたします。
            </p>
            <p>
              &nbsp;&nbsp;&nbsp;&nbsp;推奨以外のブラウザ環境でご利用いただいた場合、画面が正常に表示されない、動作しない等の可能性があります。
            </p>
            <br />
            <template v-if="checkMB">
              <p style="font-weight: bold">
                &nbsp;&nbsp;&nbsp;&nbsp;
                ＜
                <span
                  style="font-weight: bold; text-decoration: underline"
                >
                  Windows 
                </span>
                ＞
                &emsp;&emsp;
                ＜
                <span
                  style="font-weight: bold; text-decoration: underline"
                >
                  MacOS 
                </span>
                ＞
              </p>
              <p>
                &nbsp;&nbsp;&nbsp;&nbsp;
                ・Microsoft Edge
                &emsp;
                ・Safari
              </p>
              <p>
                &nbsp;&nbsp;&nbsp;&nbsp;
                ・Google Chrome
                &nbsp;&nbsp;
                ・Mozilla Firefox
              </p>
              <p>&nbsp;&nbsp;&nbsp;&nbsp;・Mozilla Firefox</p>
            </template>
            <template v-else>
              <p style="font-weight: bold">
                &nbsp;&nbsp;&nbsp;&nbsp;
                ＜
                <span
                  style="font-weight: bold; text-decoration: underline"
                >
                  Windows 
                </span>
                ＞
                &emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;
                &emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&nbsp;&nbsp; 
                ＜
                <span
                  style="font-weight: bold; text-decoration: underline"
                >
                  MacOS 
                </span>
                ＞
              </p>
              <p>
                &nbsp;&nbsp;&nbsp;&nbsp;・Microsoft
                Edge&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;
                &emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;・Safari
              </p>
              <p>
                &nbsp;&nbsp;&nbsp;&nbsp;・Google
                Chrome&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;
                &emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&nbsp;&nbsp;・Mozilla Firefox
              </p>
              <p>&nbsp;&nbsp;&nbsp;&nbsp;・Mozilla Firefox</p>
            </template>
            <br />
            <p>■ブラウザ設定をご確認ください。</p>
            <p>
              &nbsp;&nbsp;&nbsp;&nbsp;本システムはJavaScript（ジャバスクリプト）、Cookie(クッキー)を使用しております。
            </p>
            <p>
              &nbsp;&nbsp;&nbsp;&nbsp;お使いのブラウザでJavaScriptやCookieを無効にされている場合には、
              正しく動作しないことがございます。
            </p>
            <p>
              &nbsp;&nbsp;&nbsp; JavaScriptやCookieを有効にしてご利用ください。
            </p>
            <br />
            <p id="faq-2">■アカウント名をご確認ください。</p>
            <p>
              &nbsp;&nbsp;
              ログインに利用されるメールアドレスの大文字・小文字を区別します。正しく入力されているかご確認ください。
            </p>
          </li>
          <br />
          <li>
            <div class="titles">
              <div class="title l">
                2.パスワードを忘れました。どうすればよいですか？
              </div>
            </div>
            <br />
            <div class="links-top"></div>

            <p>
              ①.ログイン画面にある「パスワードを忘れた方はこちら」リンクをクリックしてください。
            </p>

            <img src="../../../static\images\ja\FQA_1.png" />
            <br />
            <p>
              ②.メールアドレス（アカウント名）を入力し、「OK」ボタンを押下します。パスワード変更案内メールが送信されます。
            </p>
            <img src="../../../static\images\ja\FQA_2.png" />
            <img src="../../../static\images\ja\FQA_3.png" />
            <br />
            <p>
              ③.パスワード変更案内メールに従い、パスワードの再設定URLをクリックし、新しいパスワードを再設定ください。
            </p>
            <!-- <p>&nbsp;&nbsp;〇〇様</p>
            <p>
              &nbsp;&nbsp;StudyArtsアカウントのパスワードリセットの申請を受け付けました。
            </p>
            <p>
              &nbsp;&nbsp;パスワードの再設定をご希望の場合は、以下URLをクリックし
            </p>
            <p>&nbsp;&nbsp;新しいパスワードをご登録ください。</p>
            <p></p>
            <p>&nbsp;&nbsp;※パスワードリセットの申請に心当たりがない場合は、</p>
            <p>&nbsp;&nbsp;　以降の対応は不要となります。</p>
            <p></p>
            <p>&nbsp;&nbsp;▼パスワードの再設定URL</p>
            <p>&nbsp;&nbsp;＜{{ url }}＞</p>
            <p>&nbsp;&nbsp;URLの期限は{{ timeoutByhour }}分です。</p>
            <p></p>
            <p>
              &nbsp;&nbsp;ご不明点等ございましたらサポートまでご連絡下さい。
            </p>
            <p>&nbsp;&nbsp;以上、よろしくお願いします。</p> -->
            <p></p>
            <p>&nbsp;&nbsp;**********************************************</p>
            <p>&nbsp;&nbsp;　StudyArtsサポートセンター</p>
            <p  id="faq-3">&nbsp;&nbsp;　メール： {{ serviceCenter }}</p>
            <p>&nbsp;&nbsp;**********************************************</p>
            <br/>
            <div class="titles">
              <div class="title l">
                3. PWA化の手順
              </div>
            </div>
            <br />
            <div class="links-top"></div>
            <p>①　スマホからSafari/Chrome/Firefoxでstudy-arts.vnのリンクをアクセスします。</p>
            <p><img src="../../../static\images\ja\manual_ja_37.png" alt="" /></p>
            <p>②　【Add to Home Screen】を開き、ホーム画面にアイコンを追加します。</p>
            <p>■Safari</p>
            <p>
              <ul>
                <li>・フッターの真ん中にある以下のアイコンをクリックすると、左の画面が表示されます。</li>
                <li>・【Add to Home Screen】のアイコンをクリックすると、「StudyArts」のインストールが完了です。</li>
              </ul>
            </p>
            <p><img src="../../../static\images\ja\manual_ja_38.png" alt="" /></p>
            <p>■Chrome</p>
            <p>
              <ul>
                <li>・縦三点のシンボルをクリックするとサイドメニューが右側から表示されます。</li>
                <li>・サイドメニューにある[Add to Home screen]のアイコンをクリックすると「Add to Home screen」ポップアップが表示されます。</li>
                <li>・「Add to Home screen」ポップアップにある【Add】のボータンをクリックすると以下のポップアップに移動します。</li>
                <li>・【Add Automatically】のボータンをクリックすると、スマホ対応の「StudyArts」がインストールできます。</li>
              </ul>
            </p>
            <p><img src="../../../static\images\ja\manual_ja_39.png" alt="" /></p>
            <p>■Firefox</p>
            <p>
              <ul>
                <li>・縦三点のシンボルをクリックするとサイドメニューが右側から表示されます。</li>
                <li>・サイドメニューにある[インストール]のアイコンをクリックすると「StudyArts」のインストールが完了です。</li>
              </ul>
            </p>
            <p><img src="../../../static\images\ja\manual_ja_40.png" alt="" /></p>
          </li>
        </ul>
      </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      url: "",
      serviceCenter: "",
      timeoutByhour: "",
      checkMB: false,
    };
  },
  mounted() {
    this.$api.post("/home/getUrlAndServiceCenter", {}).then((response) => {
      this.url = response.data.url;
      this.serviceCenter = response.data.serviceCenter;
      this.timeoutByhour = response.data.timeout;
    });
    if (this.checkMobile()) {
      this.checkMB = true;
    } else {
      this.checkMB = false;
    }
  },
  methods : {
    scrollToElement (id) {
      let element = document.getElementById(id);
      element.scrollIntoView();
    }
  }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.lkt-hover:hover {
  cursor: pointer;
}
.lkt-title{
  width: calc(100% - 109px)!important;
  font-weight: unset;
  font-size: 12pt;
  margin-top: 20px;
}
.lkt-mg-b-53{
  margin-bottom: 53px;
}
.main {
  padding-top: 60px;
}
a:hover {
  opacity: 0.7;
}

a {
  text-decoration: none;
  color: black;
  -webkit-tap-highlight-color: black;
  -webkit-user-select: none;
  -moz-user-focus: none;
  -moz-user-select: none;
}
.l {
  float: left;
}
.r {
  float: right;
}
.clear::after {
  content: ".";
  display: block;
  clear: both;
  height: 0;
  visibility: hidden;
}
.container,
.bigCourse {
  width: 1200px;
  margin: 0 auto;
}

@media screen and (min-width: 1000px) and (max-width: 1200px) {
  .container,
  .bigCourse {
    width: 1000px;
  }
}
@media screen and (min-width: 800px) and (max-width: 1000px) {
  .container,
  .bigCourse {
    width: 800px;
  }
}
@media screen and (min-width: 600px) and (max-width: 800px) {
  .container,
  .bigCourse {
    width: 600px;
  }
}
@media screen and (max-width: 600px) {
  .container,
  .bigCourse {
    width: 400px;
  }
}
@media screen and (max-width: 480px) {
  .lkt-mg-b-53{
    margin-bottom: 125px;
  }
}
@media screen and (max-width: 320px) {
  .lkt-mg-b-53{
    margin-bottom: 200px;
  }
}
.swiper-container {
  margin-bottom: 20px;
  position: relative;
  /* overflow: hidden;
    height: 450px; */
}
.swiper-container img {
  width: 100%;
}

/*中间的过度的横线*/
.link-top {
  width: 100%;
  height: 1px;
  border-top: solid black 1px;
}

/*过度的横线*/
.links-top {
  width: 100%;
  height: 1px;
  border-top: solid black 1px;
  margin-left: 39px;
}

.primarylists {
  padding-top: 10px;
}

.primarylists > ul > li {
  padding-bottom: 5px;
  overflow: hidden;
}
.primarylists ul li .titles {
  height: 90px;
  width: 1000px; /* 需要配合JS动态设置宽度 */
  padding-bottom: 5px;
  color: black;
  margin-bottom: 10px;
  display: flex;
  inline-size: max-content;
}

.secondlists > ul > li {
  padding-bottom: 10px;
  overflow: hidden;
}

.secondlists ul li .titles {
  height: 35px;
  width: 1200px; /* 需要配合JS动态设置宽度 */
  padding-left: 10px;
  color: black;
  margin-bottom: 5px;
  display: flex;
  margin-left: 30px;
}

.secondlists ul li .titles .title {
  font-size: 16px;
  line-height: 35px;
  font-weight: bold;
  text-decoration: underline;
}

.secondlists ul li img {
  height: auto;
  width: 85%;
  margin-top: 10px;
  overflow: hidden;
  margin-left: 73px;
}

.secondlists ul li p {
  font-size: 14px;
  margin-top: 10px;
  margin-left: 73px;
}

.primarylists ul li .titles img {
  width: 32px;
  height: 32px;
  margin-top: 1px;
}
.primarylists ul li .titles .title {
  font-size: 22px;
  padding: 0 20px 0 10px;
  line-height: 35px;
  font-weight: bold;
}

.primarylists ul li .titles .more {
  font-size: 16px;
  line-height: 35px;
  cursor: pointer;
  padding-right: 20px;
}
.primarylists ul li .titles .more a {
  color: black;
}

.primarylists .secondlist {
  height: 100%;
  font-size: 16px;
}
.primarylists .secondlist ul li {
  float: left;
  padding: 3px 10px;
  cursor: pointer;
  margin-right: 16px;
  background: #666;
  border-radius: 15px;
  color: white;
}
.primarylists .secondlist ul li.choose {
  background: lightskyblue;
}

.primarylists .lessons ul {
  height: 350px;
  overflow: hidden;
  transform: translateX(5px);
}

.primarylists .lessons ul li {
  width: 190px;
  height: 170px;
  float: left;
  box-sizing: border-box;
  background: #333;
  background-clip: padding-box;
  margin-right: 10px;
  margin-bottom: 10px;
  border-radius: 10px;
  overflow: hidden;
}
.primarylists .lessons ul li:nth-of-type(1) {
  width: 390px;
  height: 350px;
}
.primarylists .lessons ul li:nth-of-type(1) .img {
  height: 200px;
}
.primarylists .lessons ul li .img {
  height: 100px;
  width: 100%;
  overflow: hidden;
}
.primarylists .lessons ul li .img img {
  width: 100%;
  transition: all 0.25s ease-in-out;
  -moz-transition: all 0.25s ease-in-out;
  -webkit-transition: all 0.25s ease-in-out;
  -o-transition: all 0.25s ease-in-out;
}
.primarylists .lessons .lessontitle {
  padding: 0px 10px;
  margin: 8px 0 3px;
  color: #f8f8f8;
  font-size: 15px;
  cursor: pointer;
  /* 1行溢出隐藏 */
  display: -webkit-box;
  /*! autoprefixer: off */
  -webkit-box-orient: vertical;
  /* autoprefixer: on */
  -webkit-line-clamp: 1;
  overflow: hidden;
}
.primarylists .lessons .lessontitle:hover {
  color: lightskyblue;
}
.primarylists .lessons .introduce {
  padding: 0 10px;
  color: #999;
  font-size: 12px;

  /* 1行溢出隐藏 */
  display: -webkit-box;
  /*! autoprefixer: off */
  -webkit-box-orient: vertical;
  /* autoprefixer: on */
  -webkit-line-clamp: 1;
  overflow: hidden;
}

.primarylists .lessons .islike {
  float: right;
  margin: 2px 10px 3px 0px;
  color: #f8f8f8;
  font-size: 10px;
  cursor: pointer;
  overflow: hidden;
}

.primarylists .lessons .islike span {
  float: right;
}

.primarylists .lessons ul li:nth-of-type(1) .lessontitle {
  font-size: 16px;
  padding: 15px 20px 0 20px;
  /* 2行溢出隐藏 */
  display: -webkit-box;
  /*! autoprefixer: off */
  -webkit-box-orient: vertical;
  /* autoprefixer: on */
  -webkit-line-clamp: 2;
  overflow: hidden;
}

.primarylists .lessons ul li:nth-of-type(1) .introduce {
  font-size: 14px;
  line-height: 24px;
  padding: 10px 20px 0 20px;
  /* 3行溢出隐藏 */
  display: -webkit-box;
  /*! autoprefixer: off */
  -webkit-box-orient: vertical;
  /* autoprefixer: on */
  -webkit-line-clamp: 3;
  overflow: hidden;
}

.footer {
  padding: 50px 0 30px 0;
  color: white;
  text-align: center;
  background: url(../../../static/images/bg/myCourseBackgroundFoot.jpg)
    no-repeat center bottom;
  background-size: cover;
}
.footer .line1 {
  font-size: 46px;
}
.footer .line2 {
  font-size: 14px;
  margin-bottom: 30px;
}
.footer .line3 {
  display: inline-block;
  padding: 5px 50px;
  border: 1px solid white;
  border-radius: 20px;
}
.footer .line3:hover {
  background: white;
  color: black;
  cursor: pointer;
}
.header {
  height: 60px;
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background: #121212;
  color: white;
  z-index: 10;
  opacity: 0.8;
}
.header ul li {
  float: left;
  margin-right: 30px;
}
.header .logo {
  padding-top: 12px;
  cursor: pointer;
}
.header .logo img {
  height: 36px;
}
.header ul li div {
  height: 12px;
  font-size: 12px;
  position: relative;
}
.header ul li:hover div {
  color: #999;
}
.header ul li div span {
  height: 16px;
  width: 16px;
  line-height: 16px;
  text-align: center;
  background: red;
  color: white;
  display: block;
  border-radius: 50%;
  position: absolute;
  bottom: -8px;
  right: -18px;
}
.header ul li p {
  padding-top: 5px;
  font-size: 20px;
  text-align: center;
  color: #409eff;
}

.header .right {
  padding-top: 10px;
}
.header .right .user > div {
  margin-right: 10px;
}
.header .right .user .photo {
  height: 40px;
  width: 40px;
  border-radius: 50%;
  overflow: hidden;
  cursor: pointer;
}
.header .right .user .photo img {
  width: 100%;
}
.header .right .user .name,
.header .right .user .logout {
  font-size: 22px;
  height: 40px;
  line-height: 40px;
  cursor: pointer;
}
.header .right .user .name:hover,
.header .right .user .logout:hover {
  color: #999;
}

.header .right .search {
  margin: 0 20px;
  font-size: 22px;
  height: 40px;
  line-height: 40px;
  cursor: pointer;
}
.header .right .search:hover {
  color: #999;
}
.header .right .flag {
  height: 40px;
  width: 60px;
  cursor: pointer;
  overflow: hidden;
  border-radius: 5px;
}
.header .right .flag img {
  width: 100%;
}
.swiper_bottom_shade {
  position: absolute;
  bottom: 0;
  left: 0;
  z-index: 10;
  height: 200px;
  width: 100%;
  background: -webkit-gradient(
    linear,
    left top,
    left bottom,
    from(rgba(224, 224, 219, 0)),
    to(#fff)
  );
  background: -webkit-linear-gradient(top, rgba(224, 224, 219, 0), #fff 100%);
  background: linear-gradient(180deg, rgba(224, 224, 219, 0), #fff 100%);
}
.bigCourse {
  position: relative;
}
.bigCourse ul {
  /*background-color: rgba(255,255,255,0.7);*/
  /*border-radius: 10px;*/
  /*padding: 30px 2% 0;*/
  width: 98%;
  margin: 0 1%;
  /*position: absolute;*/
  /*bottom: 10px;*/
  /*z-index: 9;*/
}

.bigCourse li a {
  font-size: 14px;
  background-image: -webkit-linear-gradient(315deg, #02adff 0%, #00d3ff 100%);
  background-image: linear-gradient(135deg, #02adff 0%, #00d3ff 100%);
  padding: 5px 15px;
  border-radius: 5px;
  margin-right: 20px;
  float: left;
  margin-bottom: 10px;
}
.bigCourse li a:hover {
  background-image: -webkit-linear-gradient(315deg, #00d3ff 0%, #02adff 100%);
  background-image: linear-gradient(135deg, #00d3ff 0%, #02adff 100%);
}
.showAllCourse {
  position: absolute;
  right: 10px;
  top: 5px;
  cursor: pointer;
}
.showAllCourse img {
  width: 19px;
}
/* .showAllCourse i{*/
/*  font-size: 20px;*/
/*   font-weight: bold;*/
/*   color: #666;*/
/*}*/
/*.showAllCourse i :hover{*/
/*  color: #02ADFF;*/
/*}*/
.primarymenu-add {
  height: 39px;
  overflow: hidden;
}
.boxout {
}
.boxout .boxin {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  overflow-x: scroll;
  overflow-y: hidden;
  white-space: nowrap;
}
.boxout .boxin li.SchoolBusiness_menu_li {
  box-sizing: border-box;
}
::-webkit-scrollbar {
  display: none;
}

.el-tabs >>> .el-tabs__active-bar {
  height: 30px;
  background-color: #02adff;
  border-radius: 25px;
  padding: 0 20px;
  margin-left: -20px;
  margin-bottom: 5px;
}
.el-tabs >>> .el-tabs__item {
  z-index: 2;
}
.el-tabs >>> .el-tabs__nav-wrap:after {
  height: 0px;
  background-color: none;
}
.el-tabs >>> .el-tabs__nav-scroll {
  padding: 0 20px;
}
.el-tabs >>> .el-tabs__item.is-active {
  color: #fff;
}
.el-tabs >>> .toolbar {
  padding-top: 20px;
}
.el-tabs >>> .el-pager {
  margin: 0 10px;
}
.vaa :hover {
  transform: scale(1.05, 1.05);
  cursor: pointer;
}
.down_laa {
  -webkit-text-stroke-width: 2px;
  color: #999;
}
.up_laa {
  -webkit-text-stroke-width: 2px;
  color: #00d3ff;
}
.oaa {
  -webkit-text-stroke-width: 2px;
  color: #ffb821;
}
.target-fix {
  position: relative;
  top: -60px;
  display: block;
  height: 0;
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/views/index/faq_ja_new.vue